module.exports = __webpack_public_path__ + "img/icon-copy-gray.df7d05d7.svg";